<template>
  <div class="container">
    <a-form-model class="form" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules" ref="form">
      <a-tabs default-active-key="basicInfo">
        <a-tab-pane key="basicInfo" tab="基础信息">
          <a-row :gutter="[24, 0]" type="flex" align="bottom" style="width: 96%; margin: 1% auto">
            <a-col class="w-1/2">
              <a-form-model-item label="服务标识符" prop="identifier">
                <a-input disabled v-model="form.identifier" /> </a-form-model-item></a-col>
            <a-col class="w-1/2">
              <a-form-model-item label="服务项定义唯一标识" prop="encode">
                <a-input v-model="form.encode" /> </a-form-model-item></a-col>
            <a-col class="w-1/2">
              <a-form-model-item label="服务描述" prop="description.defaultMessage">
                <a-input v-model="form.description.defaultMessage" />
              </a-form-model-item>
            </a-col>
            <a-col class="w-1/2"><a-form-model-item label="超时时间" prop="timeout">
                <a-input suffix="ms" v-model="form.timeout" /> </a-form-model-item></a-col>
            <a-col class="w-full">
              <a-form-model-item label="参数项列表" prop="parameters">
                <div v-for="(parameter, index) in form.parameters" :key="index">
                  <a-card title="参数项" style="margin-top: 10px">
                    <template #extra><a-button type="link" @click="delParameter(index)">x</a-button></template>
                    <a-form-model :model="parameter" layout="vertical" ref="childForm">
                      <a-row :gutter="[24, 16]" type="flex" align="bottom">
                        <a-col class="w-1/2">
                          <a-form-model-item label="参数项标识符" prop="identifier"
                            :rules="{ required: true, message: '参数项标识符 不能为空', trigger: 'blur' }">
                            <a-input v-model="parameter.identifier" />
                          </a-form-model-item>
                        </a-col>
                        <a-col class="w-1/2">
                          <a-form-model-item label="参数项名称" prop="description.defaultMessage">
                            <a-input v-model="parameter.description.defaultMessage" /> </a-form-model-item></a-col>
                        <a-col class="w-1/2">
                          <a-form-model-item label="字段的存储类型" prop="type.type"
                            :rules="{ required: true, message: '字段的存储类型 不能为空', trigger: 'change' }">
                            <a-select v-model="parameter.type.type">
                              <a-select-option v-for="primitiveType in metaData.dataPrimitiveTypes"
                                :key="primitiveType.value" :value="primitiveType.value">{{ primitiveType.name
                                }}</a-select-option>
                            </a-select>
                          </a-form-model-item></a-col>
                        <a-col class="w-1/2">
                          <a-form-model-item label="字段的编辑方式" prop="type.editMode"
                            :rules="{ required: true, message: '字段的编辑方式 不能为空', trigger: 'change' }">
                            <a-select v-model="parameter.type.editMode">
                              <a-select-option v-for="editMode in metaData.editModes" :key="editMode.value"
                                :value="editMode.value">{{
                                  editMode.name }}</a-select-option>
                            </a-select>
                          </a-form-model-item></a-col>

                        <template v-if="
                          parameter.type.editMode === $constRepository.productFormItem.editMode.input &&
                          parameter.type.type !== $constRepository.product.DATA_PRIMITIVE_TYPES.BOOL
                        ">
                          <a-col class="w-1/2">
                            <a-form-model-item label="最小值" prop="type.range.min"
                              :rules="{ required: true, message: '最小值 不能为空', trigger: 'blur' }"><a-input
                                v-model="parameter.type.range.min" /></a-form-model-item>
                          </a-col>
                          <a-col class="w-1/2">
                            <a-form-model-item label="最大值" prop="type.range.max"
                              :rules="{ required: true, message: '最大值 不能为空', trigger: 'blur' }"><a-input
                                v-model="parameter.type.range.max" /></a-form-model-item>
                          </a-col>
                        </template>
                        <a-col class="w-1/2" v-if="
                          parameter.type.editMode === $constRepository.productFormItem.editMode.fixed ||
                          ![
                            $constRepository.productFormItem.type.string,
                            $constRepository.productFormItem.type.file,
                          ].includes(parameter.type.type)
                        ">
                          <a-form-model-item v-if="parameter.type.editMode !== null"
                            :key="`${parameter.type.editMode}defaultValue`" label="默认值" prop="type.defaultValue" :rules="parameter.type.editMode === $constRepository.productFormItem.editMode.fixed
                              ? { required: true, message: '默认值 不能为空', trigger: 'blur' }
                              : undefined
                              "><a-input v-model="parameter.type.defaultValue" /></a-form-model-item>
                        </a-col>
                        <a-row style="width: 100%" type="flex" align="bottom"
                          v-if="parameter.type.editMode === $constRepository.productFormItem.editMode.select">
                          <a-col class="w-full">
                            <a-table :data-source="parameter.type.options" :row-key="(_, index) => index">
                              <a-table-column data-index="value" key="value" title="值" align="center">
                                <template slot-scope="text, record">
                                  <a-input v-model="record.value"></a-input>
                                </template>
                              </a-table-column>
                              <a-table-column data-index="defaultMessage" key="defaultMessage" title="默认信息"
                                align="center">
                                <template slot-scope="text, record">
                                  <a-input v-model="record.description.defaultMessage"></a-input>
                                </template>
                              </a-table-column>
                              <a-table-column key="operator" title="操作" align="center">
                                <template slot-scope="text, record, optionIndex">
                                  <a-dropdown :trigger="['click']">
                                    <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                                      添加 <a-icon type="down" />
                                    </a>
                                    <a-menu slot="overlay">
                                      <a-menu-item key="0">
                                        <a-button type="link" size="small"
                                          @click="addParameterOption(index, optionIndex)">向上添加</a-button>
                                      </a-menu-item>
                                      <a-menu-divider />
                                      <a-menu-item key="1">
                                        <a-button type="link" size="small"
                                          @click="addParameterOption(index, optionIndex + 1)">向下添加</a-button>
                                      </a-menu-item>
                                    </a-menu>
                                  </a-dropdown>
                                  <a-button v-if="parameter.type.options.length > 1" type="link" size="small"
                                    class="delete-btn" @click="delParameterOption(index, optionIndex)">删除</a-button>
                                </template>
                              </a-table-column>
                            </a-table>
                          </a-col>
                        </a-row>
                      </a-row>
                    </a-form-model>
                  </a-card>
                </div>
              </a-form-model-item>
            </a-col>
            <a-col class="w-full" :push="14">
              <a-form-item>
                <a-button shape="circle" @click="addParameter"> + </a-button>
              </a-form-item></a-col>
          </a-row></a-tab-pane>
        <a-tab-pane key="codeEdit" tab="代码编辑器">
          <a-row :gutter="[24, 0]" type="flex" align="bottom" style="width: 96%; margin: 1% auto">
            <a-col class="w-full">
              <a-form-model-item label="服务编辑器" prop="description">
                <vue-json-editor v-model="form" :showBtns="false" :mode="'code'" lang="zh" style="height: 800px" />
              </a-form-model-item></a-col> </a-row></a-tab-pane></a-tabs>
      <a-row :gutter="[24, 0]" type="flex" align="bottom" style="width: 96%; margin: 1% auto">
        <a-col class="w-full">
          <a-form-item class="group-btn">
            <a-button type="primary" @click="onSubmit">保存</a-button>
            <a-button class="creator-btn" @click="$router.back()">返回</a-button>
          </a-form-item></a-col>
      </a-row>
    </a-form-model>
  </div>
</template>

<script>
import vueJsonEditor from 'vue-json-editor';
import utils from '../../../common/utils';

export default {
  name: 'ProductConfigurationEditor',
  components: { vueJsonEditor },
  async mounted() {
    if (this.$route.params.id) {
      this.getProductService(this.$route.params.id);
    }
  },
  data() {
    return {
      filterOptions: this.$constRepository.property.FILTER_NODES,
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        identifier: [{ required: true, message: '服务标识符 不能为空', trigger: 'blur' }],
        timeout: [{ required: true, validator: this.timeValidator, trigger: 'blur' }],
        encode: [{ required: true, message: '服务项定义唯一标识 不能为空', trigger: 'blur' }],
        'description.defaultMessage': [{ required: true, message: '服务描述 不能为空', trigger: 'blur' }],
      },
      form: {
        description: {},
      },
      metaData: this.$store.state.metaData,
    };
  },
  methods: {
    timeValidator(fields, option, callback) {
      if (!option) {
        callback('超时时间 不能为空');
      }
      const regex = /^\d+$/;
      if (!regex.test(option)) {
        callback('超时时间 只能为数字');
      }
      callback();
    },
    addParameterOption(index, optionIndex) {
      this.form.parameters[index].type.options.splice(optionIndex, 0, {
        value: '',
        description: {
          key: '',
          defaultMessage: '',
        },
      });
    },
    addParameter() {
      this.form.parameters.push({
        identifier: '',
        description: {
          key: null,
          defaultMessage: '',
        },
        type: {
          type: null,
          editMode: null,
          defaultValue: '',
        },
      });
    },
    delParameterOption(index, optionIndex) {
      this.form.parameters[index].type.options.splice(optionIndex, 1);
    },
    delParameter(index) {
      this.form.parameters.splice(index, 1);
    },
    async getProductService(ids) {
      const response = await this.$apiManager.productService.getproductServiceById(ids);
      this.form = response.data;
    },
    isNumber(value) {
      return !Number.isNaN(Number(value));
    },
    validateParameterDefaultValue() {
      // eslint-disable-next-line no-restricted-syntax
      for (const parameter of this.form.parameters) {
        const parameterName = parameter.description.defaultMessage;
        const { type } = parameter;
        const { editMode, defaultValue } = type;
        if (!utils.common.isLooseTruthy(defaultValue)) return true;
        if (editMode === this.$constRepository.productFormItem.editMode.input) {
          const { min, max } = type.range || {};
          if (min && max && (defaultValue < Number(min) || defaultValue > Number(max))) {
            this.$message.info(`参数项名称${parameterName}默认值不在范围区间内`);
            return false;
          }
        }

        if (editMode === this.$constRepository.productFormItem.editMode.select) {
          const { options } = type;
          const exist = options?.some((item) => item.value === defaultValue);
          if (!exist) {
            this.$message.info(`参数项名称${parameterName}默认值不在选项中`);
            return false;
          }
        }
      }
      return true;
    },
    validateParameterTypeValue() {
      // eslint-disable-next-line no-restricted-syntax
      for (const parameter of this.form.parameters) {
        const parameterName = parameter.description.defaultMessage;
        const {
          type, editMode, defaultValue, range, options,
        } = parameter.type;
        // 32位整型和浮点型
        if (
          [this.$constRepository.productFormItem.type.int32, this.$constRepository.productFormItem.type.float].includes(
            type,
          )
        ) {
          // 如果有默认值校验默认值类型
          if (utils.common.isLooseTruthy(defaultValue) && !this.isNumber(defaultValue)) {
            this.$message.info(`参数项${parameterName}:默认值请输入数字`);
            return false;
          }
          if (editMode === this.$constRepository.productFormItem.editMode.input) {
            // 输入型，校验range类型
            const { min, max } = range;
            if (!this.isNumber(min) || !this.isNumber(max)) {
              this.$message.info(`参数项${parameterName}:最小值或最大值请输入数字`);
              return false;
            }
          } else if (editMode === this.$constRepository.productFormItem.editMode.select) {
            // 选项型,校验options的值
            const hasOptionIllegal = options.some((option) => !this.isNumber(option.value));
            if (hasOptionIllegal) {
              this.$message.info(`参数项${parameterName}:选项值请输入数字`);
              return false;
            }
          }
        }
      }
      return true;
    },
    validateRangeValue() {
      // eslint-disable-next-line no-restricted-syntax
      for (const parameter of this.form.parameters) {
        const parameterName = parameter.description.defaultMessage;
        if (parameter.type.range) {
          const { min, max } = parameter.type.range;
          if (this.isNumber(min) && this.isNumber(max)) {
            const minValue = Number(min);
            const maxValue = Number(max);
            if (minValue > maxValue) {
              this.$message.info(`参数项${parameterName}:最小值不能大于最大值`);
              return false;
            }
            if (maxValue < minValue) {
              this.$message.info(`参数项${parameterName}:最大值不能小于最小值`);
              return false;
            }
          }
        }
      }
      return true;
    },
    async parametersValidator() {
      const childForm = this.$refs.childForm?.[0];
      if (!childForm) return true;

      const parameterFormValid = await new Promise((resolve) => {
        childForm.validate((res) => resolve(res));
      });
      const parameterValueValid = this.validateParameterTypeValue() && this.validateRangeValue() && this.validateParameterDefaultValue();
      return parameterFormValid && parameterValueValid;
    },

    async onSubmit() {
      const formValid = await new Promise((resolve) => {
        this.$refs.form.validate((valid) => resolve(valid));
      });
      let paramsValid = true;
      if (this.form.parameters.length > 0) {
        paramsValid = await this.parametersValidator();
      }
      if (!formValid || !paramsValid) return;
      this.$apiManager.productService.updateProductService(this.form).then(() => {
        this.$message.success('修改成功');
        this.$router.back();
      });
    },
  },
  watch: {
    'form.parameters': {
      handler(value) {
        value.forEach((parameter) => {
          if (parameter.type.editMode !== null) {
            if (
              parameter.type.editMode === this.$constRepository.productFormItem.editMode.input
              && parameter.type.range === undefined
            ) {
              this.$set(parameter.type, 'range', {
                min: '',
                max: '',
              });
              // eslint-disable-next-line no-param-reassign
              parameter.type.defaultValue = '';
              // eslint-disable-next-line no-param-reassign
              delete parameter.type.options;
              // eslint-disable-next-line no-param-reassign
              delete parameter.type.defaultValueDescription;
            }
            if (
              parameter.type.editMode === this.$constRepository.productFormItem.editMode.select
              && parameter.type.options === undefined
            ) {
              this.$set(parameter.type, 'options', [
                {
                  value: '',
                  description: {
                    key: '',
                    defaultMessage: '',
                  },
                },
              ]);
              // eslint-disable-next-line no-param-reassign
              parameter.type.defaultValue = '';
              // eslint-disable-next-line no-param-reassign
              delete parameter.type.range;
              // eslint-disable-next-line no-param-reassign
              delete parameter.type.defaultValueDescription;
            }
            if (
              parameter.type.editMode === this.$constRepository.productFormItem.editMode.fixed
              && parameter.type.defaultValueDescription === undefined
            ) {
              this.$set(parameter.type, 'defaultValueDescription', {
                key: '',
                defaultMessage: '',
              });
              // eslint-disable-next-line no-param-reassign
              delete parameter.type.options;
              // eslint-disable-next-line no-param-reassign
              delete parameter.type.range;
            }
          }
          if (parameter.type.defaultValue !== '' && parameter.type.defaultValueDescription) {
            // eslint-disable-next-line no-param-reassign
            parameter.type.defaultValueDescription.defaultMessage = parameter.type.defaultValue;
          }
        });
      },
      deep: true,
    },
    'form.description.defaultMessage': {
      handler(value) {
        this.form.remark = value;
      },
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  display: flex;
  justify-content: flex-start;

  .form {
    // padding-top: 30px;
    width: 100%;

    /deep/ .ant-form-item-label {
      width: 140px;
    }
  }
}

.option_descriptions {
  /deep/ .ant-descriptions-item-content {
    width: 115px;
    word-wrap: break-word;
  }

  /deep/ .ant-descriptions-item-label {
    width: 60px;
  }
}

/deep/.jsoneditor-poweredBy {
  display: none;
}

// /deep/.jsoneditor-outer {
//   height: 25vw;
// }
/deep/ .jsoneditor-vue {
  height: 100%;
}

.default-message-edit {
  height: 8vw;

  /deep/.jsoneditor-outer {
    height: 8vw;
  }
}

.edit-btn {
  color: green;
}

.delete-btn {
  color: red;
}

.creator-btn {
  margin-left: 2%;
}

.service-provicer-operations {
  display: flex;

  .add-btn {
    margin: 10px 0px;
    margin-left: 3%;
  }

  .service-table {
    margin-top: 2%;
  }
}

.group-btn {
  margin-left: 120px;
}

.w-1\/2 {
  width: 50%;
}

.w-1\/3 {
  width: 33.333333%;
}

.w-full {
  width: 100%;
}

.center-contaner {
  display: flex;
  justify-content: center;
  align-items: center;
}

.option-delete-button {
  display: inline;
  cursor: pointer;
  font-size: 20px;
  color: #999;
  transition: all 0.3s;
}

.option-delete-button:hover {
  color: #777;
}

.option-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
